import { useTranslation } from "react-i18next";
import { UserStatus, DocumentVersionStatus } from "../config/types";

type FieldStatusProps =
  | { dvStatus: DocumentVersionStatus }
  | { userStatus: UserStatus };

export const FieldStatus = (props: FieldStatusProps) => {
  const { t } = useTranslation();

  const label =
    "dvStatus" in props
      ? t(($) => $.commons.documentStatus[props.dvStatus])
      : t(($) => $.commons.userStatus[props.userStatus]);

  const status = "dvStatus" in props ? props.dvStatus : props.userStatus;

  const colorStyle = (): React.CSSProperties => {
    switch (status) {
      case DocumentVersionStatus.draft:
        return {
          color: "#344054",
          background: "#E4E7EC",
        };
      case DocumentVersionStatus.archived:
        return {
          color: "#B42318",
          background: "#FEF3F2",
        };
      case DocumentVersionStatus.published:
        return {
          color: "#546554",
          background: "#DDE4DD",
        };
      case UserStatus.pending:
        return {
          color: "#B54708",
          background: "#FFFAEB",
        };
      case UserStatus.active:
        return {
          color: "#027A48",
          background: "#ECFDF3",
        };
      case UserStatus.deactivated:
        return {
          color: "#344054",
          background: "#F2F4F7",
        };
      default:
        return {
          color: "fff",
          background: "000",
        };
    }
  };

  return (
    <div
      className="w-min rounded-2xl px-2 py-1 text-xs font-medium whitespace-nowrap"
      style={colorStyle()}
    >
      {label}
    </div>
  );
};
